<template>
  <section>
    <div class="pop-room project-edit-pop" v-if="noticeStatus">
      <a href="javascript:;" @click="$emit('hideNoticeDetail')" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">通知公告</h3>
        <el-col :span="23">
          <div class="ball-loading" v-if="!noticeDetail">
            <div class="k-ball-holder3">
              <div class="k-ball7a"></div>
              <div class="k-ball7b"></div>
              <div class="k-ball7c"></div>
              <div class="k-ball7d"></div>
            </div>
          </div>
          <el-form ref="form" v-else label-width="120px" class="form info-txt-center"
            style="padding-top:0;overflow:hidden;">
            <el-form-item label="标题：" class="full">
              {{noticeDetail.title}}
            </el-form-item>
            <el-form-item label="内容：" class="full">
              {{noticeDetail.content}}
            </el-form-item>
            <el-form-item label="发布时间：" class="full">
              {{noticeDetail.createTime}}
            </el-form-item>
            <el-form-item label="发布人：" class="full">
              <user-info :userData='noticeDetail.creator'></user-info>
            </el-form-item>
            <el-form-item label="相关附件：" class="full" v-if="noticeDetail.attachments.length>0">
              <file-link v-for="item,i in noticeDetail.attachments" :key="i" :item="item"></file-link>
            </el-form-item>

            <div v-if="isManager">
              <el-form-item label="公司/部门权限：" class="full">
                <div class="contact-user-list" v-if="noticeDetail.departments">
                  <div class="user-item" v-for="user,j in noticeDetail.departments">
                    <span class="name">{{user.name}}</span>
                  </div>
                </div>
                <div v-else>未选择</div>
              </el-form-item>
              <el-form-item label="人员权限：" class="full">
                <div v-if="noticeDetail.users">
                  <div class="user-item" v-for="user,j in noticeDetail.users">
                    <span class="name">{{user.name}}</span>
                  </div>
                </div>
                <div v-else>未选择</div>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  import FileLink from '@/components/FileLink'
  export default {
    components: {
      UserInfo,
      FileLink,
    },
    props: ['noticeStatus', 'noticeDetail', 'isManager'],
    methods: {}
  }
</script>


// WEBPACK FOOTER //
// src/page/notice/components/noticeDetail.vue